import { useTranslation } from "react-i18next";
import { Check, Circle } from "lucide-react";
import { passwordRules } from "../../lib/passwordPolicy";

// قائمة شروط حيّة: كل شرط يتحوّل إلى ✓ أخضر لحظة تحقّقه أثناء الكتابة.
export const PasswordRules = ({ value, className = "" }) => {
  const { t } = useTranslation();

  return (
    <ul className={`grid gap-1 sm:grid-cols-2 ${className}`} data-testid="password-rules">
      {passwordRules(value).map((rule) => (
        <li
          key={rule.key}
          data-testid={`password-rule-${rule.key}`}
          data-ok={rule.ok ? "true" : "false"}
          className={`flex items-center gap-1.5 text-[11px] font-semibold transition-colors duration-200 ${
            rule.ok ? "text-emerald-600" : "text-muted-foreground"
          }`}
        >
          {rule.ok ? <Check className="h-3.5 w-3.5" /> : <Circle className="h-3 w-3" />}
          {t(`auth.rules.${rule.key}`)}
        </li>
      ))}
    </ul>
  );
};
